import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';

import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';

import { AppCard, AppFieldBox } from 'components/appComponents';
import ModalFooter from 'components/appModalFooter';
import { Button, SelectBox, ValidationGroup, Validator } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';
import { isSuccess } from 'utils/responseStatus';

import { useChangeStatusComingNomenclatureMainMutation } from 'bus/comingNomenclatureMain/services/main';

type StatusProps = {
  value: number | null;
  readOnly: boolean;
};

export const Status: FC<StatusProps> = ({ value, readOnly }) => {
  const { id } = useParams<{ id: string }>();
  const [items, setItems] = useState<Array<{ name: string; id: number }>>([]);
  const [status, setStats] = useState(value);
  const [visible, setVisible] = useState(false);

  const [changeStatusComingNomenclatureMain, { isLoading }] = useChangeStatusComingNomenclatureMainMutation();

  const statusDateSource = async () => {
    const data = await $createStore('/v1/ComingNomenclature/statuses', 'id').load();
    setItems(data as any);
  };

  useEffect(() => {
    statusDateSource();
  }, []);

  const handleSubmit = () => {
    changeStatusComingNomenclatureMain({ id: Number(id), status: Number(status) }).then((data) => {
      if (isSuccess(data)) {
        toast.success('Статус успешно изменен', {
          position: 'bottom-right',
        });
        setVisible(false);
      }
    });
  };

  const currentStatus = items.find((item) => item.id === value);

  return (
    <AppCard className="mb-2">
      <Button
        width={'100%'}
        text={currentStatus?.name}
        type="normal"
        stylingMode="text"
        onClick={() => setVisible(true)}
        disabled={readOnly}
      />

      <Popup
        visible={visible}
        onHiding={() => setVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Смена статуса"
        width={400}
        onShowing={() => setVisible(true)}
        onHidden={() => setVisible(false)}
        height={'auto'}
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit} action="add-edit-legal">
              <ValidationGroup>
                <Form>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppFieldBox label="Статус" labelTop>
                      <SelectBox
                        stylingMode="underlined"
                        placeholder="Выберите статус"
                        mode="text"
                        value={status}
                        onItemClick={(e) => setStats(e.itemData.id)}
                        displayExpr="name"
                        valueExpr="id"
                        items={items}
                      >
                        <Validator>
                          <RequiredRule message="Заполните поле статус" />
                        </Validator>
                      </SelectBox>
                    </AppFieldBox>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => setVisible(false)}
                  disabledSubmit={isLoading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </AppCard>
  );
};
